export default __webpack_public_path__ + "static/Icon-tshirt-b63348c2ba301a532e4dbf3d2c8d6d65.svg";